import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map, catchError, of } from 'rxjs';
import { environment } from '../../environments/environment';
import { CallPlan } from '../models/attendee.model';
import { CallPlanVerifyResponse } from '../models/backend-response.model';

@Injectable({
  providedIn: 'root'
})
export class CallPlanService {
  private apiUrl = environment.apiUrl;
  private companyId = environment.companyId;

  constructor(private http: HttpClient) {}

  verifyCallPlan(data: {
    cats_num?: string;
    first_name?: string;
    last_name?: string;
    license?: string;
    license_state?: string;
    is_hcp?: string;
  }): Observable<CallPlan | null> {
    const url = `${this.apiUrl}/api/companies/${this.companyId}/contacts/verify`;
    
    const contact: Record<string, unknown> = {};
    if (data.cats_num) {
      contact['npi_no'] = data.cats_num;
    }
    if (data.first_name) contact['first_name'] = data.first_name;
    if (data.last_name) contact['last_name'] = data.last_name;
    
    if (data.license && data.license_state) {
      contact['licenses'] = [{
        license: data.license,
        state: data.license_state
      }];
    }
    
    if (data.license_state) {
      contact['default_address'] = {
        state: data.license_state
      };
    }
    
    const payload = {
      contact,
      verifiedField: 'first_name' as const
    };
    
    return this.http.post<CallPlanVerifyResponse>(url, payload).pipe(
      map(result => {
        if (result?.verified && result.callPlan) {
          const callPlan = result.callPlan;
          return {
            id: callPlan.id,
            compass_id: callPlan.compass_id ? String(callPlan.compass_id) : String(callPlan.id),
            first_name: callPlan.first_name || data.first_name,
            last_name: callPlan.last_name || data.last_name,
            city: callPlan.city,
            state: callPlan.state,
            license_state: callPlan.license_state,
            license: callPlan.state_license_number,
            degrees: Array.isArray(callPlan.degrees) ? callPlan.degrees.join(', ') : (callPlan.degrees || ''),
            specialty: callPlan.specialty || callPlan.subspecialty,
            contact_type: callPlan.contact_type,
            affiliation: callPlan.affiliation,
            address1: callPlan.address1,
            address2: callPlan.address2,
            zip: callPlan.zip
          };
        }
        return null;
      }),
      catchError(() => of(null))
    );
  }
}


